export const folderKeys = {
  all: ['filetree'] as const,
  root: () => [...folderKeys.all, 'root'] as const,
  detail: (id: number | undefined) => [...folderKeys.all, 'folder', id] as const,
};
